import "./assets/css/normalize.css";
import "./assets/css/base.css";
import "./assets/css/utils.css";
import "./assets/css/public.css";
import "./plugins/element.js";
import "./plugins/filters.js";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import mock from "./mock";
import store from "./store";
import api from "./api";

//执行mock 拦截
// mock();

Vue.config.productionTip = false;

// Vue.prototype.$api = api; // 将api挂载到vue的原型上复制代码

//全局混入
Vue.mixin({
  methods: {
    //路由定向方法
    redirectByPath(path, query) {
      this.$router.push({ path, query });
    },
    //请求数据方法
    requestApi(module, method, params, successCallback) {
      api[module][method](params)
        .then(res => {
          successCallback(res);
        })
        .catch(reason => {
          // eslint-disable-next-line no-console
          console.log(reason);
        });
    }
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
